import { Atom } from 'AppReact';
import styled, { css } from "styled-components";

const template = styled.input`
  ${({ displayState }) => css`
    width: ${displayState?.width ?? '64px'};
    height: ${displayState?.height ?? '27px'};
    font-size: ${displayState?.fontSize ?? '14px'};
    padding: ${displayState?.padding ?? '4px'};
    color: ${displayState?.color ?? '#04333B'};
    border: ${displayState?.border ?? '1px solid #E3E3E3'};
    background-color: ${displayState?.background ?? ''};
    border-bottom: ${displayState?.borderBottom ?? ''};
    border-radius: ${displayState?.borderRadius ?? '6px'};
    outline: ${displayState?.outline ?? '#1DBD6B'};
  `}
`;


export default Atom({ type: 'notClickableInput', dataType: ['string', 'number'], template })